export const theme = {
  type: {
    primary: '#1D1E20',
    secondary: '#62656A',
    disabled: '#BFC4CA',
  },
  divider_and_border: {
    body_divider: '#DFE2E4',
    input_border: '#BFC4CA',
    input_border_hover: '#35373B',
  },
  gradients: {
    gradient001: 'linear-gradient(181.11deg, #051C2C 1.02%, #011F59 99.13%)',
    gradient002: 'linear-gradient(180deg, #183DDB -36.11%, #7B29FF 140.74%)',
    gradient003: 'linear-gradient(180deg, #0578FF 0%, #10A9FF 100%)',
  },
  primary: {
    primary10: '#CCEAF7',
    primary20: '#99D4F0',
    primary30: '#0094D9',
    primary40: '#33A9E1',
    primary50: '#0094D9',
    primary60: '#0094D9',
    primary70: '#0066A8',
    primary80: '#323232',
    primary90: '#004A7D',
  },

  status: {
    success: {
      light: '#D5FCE7',
      medium: '#13B966',
      dark: '#074526',
    },
    alert: {
      light: '#FFF8DA',
      medium: '#FFD738',
      dark: '#3E3200',
    },
    error: {
      light: '#FDECED',
      medium: '#EA3E4F',
      dark: '#A0121F',
    },
    info: {
      info_background: '#D3EFFF',
      info_signal: '#10A9FF',
      info_status: '#005B8E',
    },
  },
  overlay: {
    light: 'rgba(255, 255, 255, 0.4)',
    dark: 'rgba(29, 30, 32, 0.4)',
  },
  neutrals: {
    white: '#FFFFFF',
    black: '#000000',
  },
  greys: {
    grey000: '#FAFAFB',
    grey010: '#EFF0F2',
    grey020: '#DFE2E4',
    grey030: '#CFD3D7',
    grey040: '#BFC4CA',
    grey050: '#B0B3B9',
    grey060: '#8C8F96',
    grey070: '#71747B',
    grey080: '#62656A',
    grey090: '#4D4F54',
    grey100: '#35373C',
    grey110: '#1D1E20',
  },
};

export const catalanaOccidenteTheme = {
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#FFD6D8',
    primary20: '#F39DAD',
    primary30: '#DC0028',
    primary40: '#DA2647',
    primary50: '#DC0028',
    primary60: '#DC0028',
    primary70: '#b00020',
    primary80: '#323232',
    primary90: '#828282',
  },
};

export const realeTheme = {
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#ccdbeb',
    primary20: '#99b7d7',
    primary30: '#004B9B',
    primary40: '#336faf',
    primary50: '#004B9B',
    primary60: '#004B9B',
    primary70: '#004b9b',
    primary80: '#323232',
    primary90: '#FFB300',
  },
};

export const helvetiaTheme = {
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#E1D9FF',
    primary20: '#00818F',
    primary30: '#00818F',
    primary40: '#00818F',
    primary50: '#000D6E',
    primary60: '#8861A9',
    primary70: '#000D6E',
    primary80: '#C31622',
    primary90: '#8861A9',
  },
};

export const unionAlcoyanaTheme = {
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#d0d0e4',
    primary20: '#a1a1c8',
    primary30: '#141476',
    primary40: '#434391',
    primary50: '#141476',
    primary60: '#00A3E0',
    primary70: '#10105e',
    primary80: '#323232',
    primary90: '#00A3E0',
  },
};

export const segurosBilbaoTheme = {
  //review
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#FFD6D8',
    primary20: '#F39DAD',
    primary30: '#DC0028',
    primary40: '#DA2647',
    primary50: '#DC0028',
    primary60: '#DC0028',
    primary70: '#b00020',
    primary80: '#323232',
    primary90: '#828282',
  },
};

export const mgsTheme = {
  // review
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#ccd6e6',
    primary20: '#99accd',
    primary30: '#FF8500',
    primary40: '#33599b',
    primary50: '#003082',
    primary60: '#003082',
    primary70: '#002668',
    primary80: '#323232',
    primary90: '#003082',
  },
};

export const plusUltraTheme = {
  // review
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#FFD6D8',
    primary20: '#F39DAD',
    primary30: '#DC0028',
    primary40: '#DA2647',
    primary50: '#DC0028',
    primary60: '#DC0028',
    primary70: '#b00020',
    primary80: '#323232',
    primary90: '#828282',
  },
};

export const gesSegurosTheme = {
  // review
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#f9ccd1',
    primary20: '#f399a3',
    primary30: '#E2001A',
    primary40: '#e83348',
    primary50: '#E2001A',
    primary60: '#E2001A',
    primary70: '#b50015',
    primary80: '#323232',
    primary90: '#6A6B6F',
  },
};

export const caserTheme = {
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#DEF6F7',
    primary20: '#007363',
    primary30: '#007363',
    primary40: '#007363',
    primary50: '#007363',
    primary60: '#7A6A08',
    primary70: '#007363',
    primary80: '#EC7A08',
    primary90: '#7A6A08',
  },
};

export const fiatcTheme = {
  ...theme,
  primary: {
    ...theme.primary,
    primary10: '#E5EAEE',
    primary20: '#002A5C',
    primary30: '#002A5C',
    primary40: '#002A5C',
    primary50: '#002A5C',
    primary60: '#7A1C5C',
    primary70: '#002A5C',
    primary80: '#ED1C24',
    primary90: '#7A1C5C',
  },
};

export const defaultPalette = {
  primaryCol: theme.primary.primary80,
  secondaryCol: theme.primary.primary50,
  disabledPrimary: theme.primary.primary10,
  iconCol: theme.primary.primary80,
  iconBgCol: theme.primary.primary10,
};

export const defaultIconCol = {
  '00000016': theme.primary.primary50,
  '00000001': segurosBilbaoTheme.primary.primary50,
  '00000002': catalanaOccidenteTheme.primary.primary50,
  '00000006': gesSegurosTheme.primary.primary50,
  '00000011': helvetiaTheme.primary.primary50,
  '00000010': mgsTheme.primary.primary50,
  '00000020': plusUltraTheme.primary.primary50,
  '00000025': realeTheme.primary.primary50,
  '00000007': unionAlcoyanaTheme.primary.primary50,
  '00000060': caserTheme.primary.primary50,
};
